module.exports = __webpack_public_path__ + "img/sad-thing.078d684e.gif";